import { useTranslation } from "react-i18next"
// icons
import { FaRegUser } from "react-icons/fa"
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2"
import { HiOutlineMail } from "react-icons/hi"
import { BiSupport } from "react-icons/bi";
import { FaTag } from "react-icons/fa";
// herlpers
import size from 'lodash/size'
import isEmpty from "lodash/isEmpty"

const getString = (val) => {
  if (size(val) > 0) return val
  return '-'
}

interface TicketInterface {
  id: string
  email: string
  phone: string
  name: string
  type: string
  sdk_version: string
}

const TicketCard: React.FC<TicketInterface> = ({ id,
  email,
  phone,
  name,
  type,
  sdk_version, }) => {
  const { t } = useTranslation()

  return (
    <div className="account">
      <h3>Ticket cerrado</h3>
      <div className="userAttribute">
        <span><FaRegUser color="#0061df" /> {t('USER_NAME')}</span>
        {getString(name)}
      </div>
      <div className="userAttribute">
        <span><HiOutlineMail color="#0061df" /> {t("USER_EMAIL")}</span>
        {getString(email)}
      </div>
      <div className="userAttribute">
        <span><HiOutlineDevicePhoneMobile color="#0061df" /> {t("USER_PHONE")}</span>
        {getString(phone)}
      </div>

      <div className="userAttribute">
        <span><BiSupport color="#0061df" /> Tipo</span>
        {getString(type)}
      </div>
      <div className="userAttribute">
        <span><BiSupport color="#0061df" /> Version de SDK</span>
        {getString(sdk_version)}
      </div>
    </div>
  )
}

export default TicketCard